import { render, staticRenderFns } from "./clearance.vue?vue&type=template&id=54124882&"
import script from "./clearance.vue?vue&type=script&lang=js&"
export * from "./clearance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports